import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const ReservationTimer = ({ currentTime, expiryTime, logout }) => {
  const { t } = useTranslation()
  const [timeLeft, setTimeLeft] = useState(Math.max(expiryTime - currentTime, 0));

  useEffect(() => {
    // console.log("timeLeft", timeLeft);
    // console.log("expiryTime", expiryTime - currentTime);

    if (timeLeft <= 0) {
      logout();
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const next = prev - 1000;
        if (next <= 0) {
          clearInterval(interval);
          logout(); // Call logout when time is up
          return 0;
        }
        return next;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, logout]);

  const minutes = Math.floor(timeLeft / 1000 / 60);
  const seconds = Math.floor((timeLeft / 1000) % 60);

  return (
    timeLeft > 0 ? (<div className="flex flex-col gap-3 justify-center items-center bg-white p-2">
      {timeLeft > 0
        ? t("error.reservationExpiredInTime", { minutes, seconds })
        // : "Reservation expired."}
        : t("error.reservationExpired")}
    </div>) : <></>
  );
};

export default ReservationTimer;
